export default __webpack_public_path__ + "static/media/image.serverclub-lk-pvt-ltd.dbd83f96.png";